/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { ReactComponent as BrainIcon } from "assets/icons/Brain-2.svg";
import { w100css } from "assets/css/dimensions";
import Popper from "components/common/Popper";
import EmotionReactModal from "components/EmotionReactModal";
import ModalHeader from "components/common/ModalHeader";
import useEvent from "hooks/useEvent";
import useRouterSearchParams from "hooks/useRouterSearchParams";
import { modalContentCss, modalCss, overlayCss } from "./index.css";
import ModalContent from "./ModalContent";
import tableActionFieldCss from "../index.css";

export default function EmailThreadDetailModal({ isOpen, rowData, onCloseModal, onOpenModal }) {
  const [searchParams, setSearchParams] = useRouterSearchParams();

  const onModalClose = useEvent(() => {
    if (searchParams.has("originalMailId")) {
      const newSearchParams = new URLSearchParams(searchParams);

      newSearchParams.delete("originalMailId");

      setSearchParams(newSearchParams);
    }

    onCloseModal();
  });

  return (
    <>
      <Popper text="Details">
        <button type="button" css={tableActionFieldCss.sendBtn} onClick={onOpenModal}>
          <BrainIcon />
        </button>
      </Popper>

      <EmotionReactModal
        isOpen={isOpen}
        onRequestClose={onModalClose}
        overlayClassName={overlayCss}
        className={modalCss}
        shouldCloseOnOverlayClick
      >
        <div
          css={[tableActionFieldCss.container, w100css, modalContentCss]}
          className="flex-column"
        >
          <div>
            <ModalHeader handleClose={onModalClose} />
          </div>
          <ModalContent rowData={rowData} />
        </div>
      </EmotionReactModal>
    </>
  );
}

EmailThreadDetailModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseModal: PropTypes.func.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  prospectInfo: PropTypes.shape({}),
  template: PropTypes.shape({}),
  rowData: PropTypes.shape({}),
};
